<template>
  <v-card class="elevation-0">
    <v-toolbar color="teal" dark flat dense cad>
      <v-toolbar-title class="subheading">Policies Info</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list class="pa-0">
        <template v-for="(item, index) in items">
          <v-subheader v-if="item.header" :key="item.header">{{
            item.header
          }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="index"></v-divider>
          <v-list-tile
            v-else
            :key="item.title"
            @click="handleClick(item.index)"
          >
            <v-list-tile-content>
              <v-list-tile-sub-title
                v-html="item.title"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        index: 0,
        title: "Policies Infomation"
      }
      // {
      //   index: 1,
      //   title: "Student Image"
      // }
    ]
  }),
  methods: {
    handleClick(index) {
      this.$emit("listChanged", index);
    }
  }
};
</script>
